require('../modules/esnext.composite-key');
require('../modules/esnext.composite-symbol');